<router-outlet></router-outlet>
<!-- <div *ngIf="isUserIdle">
    User is idle
    <button (click)="reset()">Reset</button>
  </div> -->

 